document.addEventListener('DOMContentLoaded', function () {
  const context = sessionStorage.getItem('collection_context');
  if (context !== 'kids-playground-equipment') return;

  const variantRadios = document.querySelector('variant-radios');
  const variantSelects = document.querySelector('variant-selects');
  const container = variantRadios || variantSelects;
  if (!container) return;

  const shippingDataEl = container.querySelector('script[data-variant-shipping]');
  if (!shippingDataEl) return;

  let variantShippingData;
  try {
    variantShippingData = JSON.parse(shippingDataEl.textContent);
  } catch(e) { return; }

  const variants = Object.values(variantShippingData);

  function getSelectedOptions() {
    const options = {};
    if (variantRadios) {
      variantRadios.querySelectorAll('fieldset').forEach((fs, idx) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) options['option' + (idx + 1)] = checked.value;
      });
    } else if (variantSelects) {
      variantSelects.querySelectorAll('select').forEach((sel, idx) => {
        options['option' + (idx + 1)] = sel.value;
      });
    }
    return options;
  }

  function hasAvailableVariant(option1Value) {
    return variants.some(v => v.option1 === option1Value && !v.hide_shipping);
  }

  function selectOption(fieldset, value) {
    if (variantRadios) {
      const radio = fieldset.querySelector('input[type="radio"][value="' + CSS.escape(value) + '"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (variantSelects) {
      const select = fieldset.querySelector('select');
      if (select && select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function initializeValidSelection() {
    const fieldsets = container.querySelectorAll('fieldset, .product-form__input--dropdown');
    if (fieldsets.length === 0) return;

    const firstFieldset = fieldsets[0];
    const currentOption1 = getSelectedOptions()['option1'];
    
    if (currentOption1 && hasAvailableVariant(currentOption1)) return;

    const inputs = firstFieldset.querySelectorAll('input[type="radio"], select option');
    for (const input of inputs) {
      if (hasAvailableVariant(input.value)) {
        selectOption(firstFieldset, input.value);
        return;
      }
    }
  }

  function updateVisibleOptions() {
    const selectedOptions = getSelectedOptions();
    const fieldsets = container.querySelectorAll('fieldset, .product-form__input--dropdown');

    fieldsets.forEach((fieldset, optionIndex) => {
      const optionKey = 'option' + (optionIndex + 1);
      const inputs = fieldset.querySelectorAll('input[type="radio"], select option');
      let anyVisible = false;

      inputs.forEach(input => {
        const value = input.value;
        let shouldHide = true;

        for (const variantId in variantShippingData) {
          const v = variantShippingData[variantId];
          if (v[optionKey] !== value) continue;

          let matchesOtherOptions = true;
          for (let i = 1; i <= 3; i++) {
            const key = 'option' + i;
            if (i === (optionIndex + 1)) continue;
            if (selectedOptions[key] && v[key] !== null && v[key] !== selectedOptions[key]) {
              matchesOtherOptions = false;
              break;
            }
          }

          if (matchesOtherOptions && !v.hide_shipping) {
            shouldHide = false;
            break;
          }
        }

        if (!shouldHide) anyVisible = true;

        if (input.tagName === 'INPUT') {
          input.style.display = shouldHide ? 'none' : '';
          const label = document.querySelector('label[for="' + input.id + '"]');
          if (label) label.style.display = shouldHide ? 'none' : '';
        } else if (input.tagName === 'OPTION') {
          input.style.display = shouldHide ? 'none' : '';
          input.disabled = shouldHide;
        }
      });

      fieldset.style.display = anyVisible ? '' : 'none';

      const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
      if (checkedRadio && checkedRadio.style.display === 'none') {
        const firstVisible = fieldset.querySelector('input[type="radio"]:not([style*="display: none"])');
        if (firstVisible) {
          firstVisible.checked = true;
          firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  initializeValidSelection();
  setTimeout(updateVisibleOptions, 10);

  container.querySelectorAll('input[type="radio"], select').forEach(el => {
    el.addEventListener('change', function() {
      setTimeout(updateVisibleOptions, 50);
    });
  });
});
